import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import { TableCell } from "~/components/TableView/TableCell";
export const StaticHeader = /*#__PURE__*/ memo((param)=>{
    let { title, className, resizeHandle, ...props } = param;
    return /*#__PURE__*/ _jsxs(TableCell, {
        className: tailwindMerge("p-1.5 px-2", className, !!resizeHandle && "relative"),
        ...props,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "group flex h-8 items-center justify-start border-0 bg-transparent py-0 text-12 font-semibold text-grey-11",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "truncate",
                    children: title
                })
            }),
            resizeHandle
        ]
    });
});
StaticHeader.displayName = "StaticHeader";
